export enum language {
  default = 'ar',
  ar = 'ar',
  en = 'en',
}
